import { render, staticRenderFns } from "./CustomerPointsDetails.vue?vue&type=template&id=f6098634&scoped=true&"
import script from "./CustomerPointsDetails.vue?vue&type=script&lang=js&"
export * from "./CustomerPointsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6098634",
  null
  
)

export default component.exports